// const CHAT_API_BASE_URL = "http://62.171.153.83:8080/tappme-api-development/ws";
// const CHAT_API_BASE_URL = "http://localhost:8080/ws";
const CHAT_API_BASE_URL =
  "https://tappme-api.digitalnoticeboard.biz/tappme-api-development/ws";
export { CHAT_API_BASE_URL };
